var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-app-bar',{attrs:{"dense":"","dark":"","app":""}},[_c('v-spacer'),_c('LangMenu')],1),_c('v-main',[_c('v-container',{staticClass:"fill-height primary",attrs:{"fluid":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }